const messages = {
  internalError: 'Ocorreu um erro inesperado! Por gentileza, entre em contato com: faleconosco@zonasul.com.br',
}

const m = (ref) => {
  return messages[ref] || ref;
}

export default m;
